import { render, staticRenderFns } from "./TableConfigurationProvider.vue?vue&type=template&id=6734dbcc&scoped=true&"
import script from "./TableConfigurationProvider.vue?vue&type=script&lang=js&"
export * from "./TableConfigurationProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734dbcc",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QCardActions,QBtn});
